<template>
  <div class="info" v-loading="loading">
    <back />
    <div class="s_wrapper">
      <el-input class="s_input" v-model="userName" placeholder="搜索用户名称" suffix-icon="el-icon-search"
        @change="handleSearch" clearable></el-input>
      <el-input class="s_input" v-model="phoneNum" placeholder="搜索电话号码" suffix-icon="el-icon-search"
        @change="handleSearch" clearable></el-input>
    </div>
    <div class="activityName">活动名称：{{ this.$route.query.activityName }}</div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="图片" min-width="80">
          <template slot-scope="scope">
            <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
            <div style="color: #069BBC;cursor: pointer;" @click="handleCarouselUrl(scope.row.userPicture)">查看图片</div>
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="userName" label="姓名"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="gender" label="用户性别">
          <template slot-scope="scope">
            <span v-if="scope.row.gender === 0">女</span>
            <span v-if="scope.row.gender === 1">男</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="100" show-overflow-tooltip prop="" label="出生日期"></el-table-column> -->
        <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
          <template slot-scope="scope">
            <span>{{ scope.row.phoneNum || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="报名时间" sortable>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="voteCount" label="总票数" sortable
          v-if="this.$route.query.activityType == 0"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="ranking" label="排名" sortable
          v-if="this.$route.query.activityType == 0"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleCommand(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      userName: "",
      phoneNum: "",
      tableData: [],
      srcList: null, //大图预览

      currentPage: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50],
      totalCount: 0,
    }
  },
  created() {
    this.getRequestList();
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .post(this.$api.activityRegisterList, {
          id: this.$route.query.id,
          userName: this.userName || null,
          phoneNum: this.phoneNum || null,
          rankingType: null,//排名排序：0倒序；1顺序
          timeType: null,//时间排序：0倒序；1顺序
          voteCountType: null,//票数排序：0倒序；1顺序
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 查看图片
    handleCarouselUrl(imageUrl) {
      this.srcList = null
      if (imageUrl) {
        this.srcList = [imageUrl];
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传活动图片!");
      }
    },
    //查看报名详情
    handleCommand(row) {
      this.$router.push({ name: 'activityRegisterDet', query: { id: row.id, } })
    },
    // 搜索
    handleSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e;
      this.getRequestList();
    },

    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e;
      this.getRequestList();
    }
  }
}
</script>

<style lang="scss" scoped>
.activityName {
  font-weight: 400;
  font-size: 20px;
  margin-bottom: 20px;
}
</style>